"use client";

import { useState } from "react";
import type { ImageDataType } from "@/shared/types";
import type { GalleryControlsTheme } from "./types";
import { GalleryLightbox } from "./GalleryLightbox";
import { ImageCarousel } from "./ImageCarousel";
import { ImageGridGallery } from "./ImageGridGallery";

export type ImageGalleryLayout = "carousel" | "grid";

interface ImageGalleryProps {
  images: ImageDataType[];
  layout?: ImageGalleryLayout;
  columnsPerRow?: 2 | 3 | 4;
  controlsTheme?: GalleryControlsTheme;
  gridShellClass?: string;
  gridCellClass?: string;
  className?: string;
}

export function ImageGallery({
  images,
  layout = "carousel",
  columnsPerRow = 3,
  controlsTheme,
  gridShellClass,
  gridCellClass,
  className,
}: ImageGalleryProps) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  return (
    <>
      {layout === "grid" ? (
        <ImageGridGallery
          images={images}
          columnsPerRow={columnsPerRow}
          onImageClick={openLightbox}
          gridShellClass={gridShellClass}
          gridCellClass={gridCellClass}
          className={className}
        />
      ) : (
        <ImageCarousel
          images={images}
          onImageClick={openLightbox}
          controlsTheme={controlsTheme}
          isAutoplayPaused={isLightboxOpen}
          className={className}
        />
      )}

      {isLightboxOpen && (
        <GalleryLightbox
          images={images}
          initialIndex={lightboxIndex}
          onClose={closeLightbox}
        />
      )}
    </>
  );
}
